import { render, staticRenderFns } from "./user-order.vue?vue&type=template&id=10e8dd3d&scoped=true&"
import script from "./user-order.vue?vue&type=script&lang=js&"
export * from "./user-order.vue?vue&type=script&lang=js&"
import style0 from "./user-order.vue?vue&type=style&index=0&id=10e8dd3d&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e8dd3d",
  null
  
)

export default component.exports